import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    '& .MuiDialog-paper': {
      height: '94vh',
      width: '50%',
      [theme.breakpoints.down('lg')]: {
        width: '60%',
      },
      [theme.breakpoints.down('md')]: {
        width: '70%',
      },
      [theme.breakpoints.down('sm')]: {
        width: '90%',
      },
    },
    '& .MuiDialogTitle-root': {
      backgroundColor: theme.palette.custom.main,
      color: '#fff',
      padding: '8px 20px',
    },
    '& .MuiDialogTitle-root+.MuiDialogContent-root ': {
      paddingTop: 20,
    },
    '& .MuiDialogContent-root': {
      padding: '20px 20px',
    },
    '& .MuiDialogActions-root': {
      paddingInlineEnd: 24,
    },
  },
  root: {
    rowGap: 16,
  },
  slotLabel: {
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
  },
  slotWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 12,
    paddingBlock: 12,
  },
  slot: {
    width: 200,
    border: `1px solid ${theme.palette.custom.main}`,
    borderRadius: 20,
    display: 'flex',
    justifyContent: 'center',
    paddingBlock: 6,
    cursor: 'pointer',
    '& .MuiTypography-root': {
      color: theme.palette.custom.main,
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
      },
    },
    '&:hover': {
      backgroundColor: theme.palette.custom.main,
      '& .MuiTypography-root': {
        color: '#fff',
      },
    },
    [theme.breakpoints.down('md')]: {
      width: 148,
    },
  },
  disabledSlot: {
    pointerEvents: "none",
    opacity: "0.3",
  },
  activeSlot: {
    backgroundColor: theme.palette.custom.main,
    '& .MuiTypography-root': {
      color: '#fff',
    },
  },
  error: {
    '& .MuiTypography-root': {
      color: theme.palette.error.main,
    },
  },
}))

export default useStyles
